import React from "react";
import {
  Box,
  Typography,
  Divider,
  Button,
  Stack,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useCart } from "../../context/CartContext";
import CartSummaryBreakdown from "../../components/cart/CartSummaryBreakdown";

const CartSummaryBox = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const { user, isAuthenticated } = useAuth();
  const { cartSubtotal, totalDiscount, cartTotal } = useCart();

  const handleGuestCheckout = () => {
    console.log("fsdf");
    navigate("/checkout?mode=guest");
  };

  const handleMemberCheckout = () => {
    if (user && isAuthenticated) {
      navigate("/checkout?mode=member");
    } else {
      navigate("/login", {
        state: {
          returnTo: "/checkout?mode=member",
        },
      });
    }
  };

  return (
    <Box
      sx={{
        border: "1px solid #E0E0E0",
        borderRadius: "16px",
        p: 3,
        backgroundColor: "#fff",
      }}>
      <Typography variant="h6" fontWeight="bold" gutterBottom>
        Summary
      </Typography>

      <Divider sx={{ mb: 2 }} />

      <CartSummaryBreakdown
        subtotal={cartSubtotal}
        totalDiscount={totalDiscount}
        total={cartTotal}
        showTaxNote
      />

      <Stack spacing={2} mt={3}>
        {user ? (
          <Button
            variant="contained"
            fullWidth
            onClick={handleMemberCheckout}
            sx={{
              borderRadius: "999px",
              fontWeight: 600,
              py: 1.5,
              fontSize: isMobile ? "0.95rem" : "1rem",
              color: "#fff",
              "&:hover": {
                backgroundColor: "#FD7762",
              },
            }}>
            Go To Checkout
          </Button>
        ) : (
          <>
            <Button
              variant="contained"
              fullWidth
              onClick={handleGuestCheckout}
              sx={{
                borderRadius: "999px",
                fontWeight: 600,
                py: 1.5,
                fontSize: isMobile ? "0.95rem" : "1rem",
              }}>
              Guest Checkout
            </Button>
            <Button
              variant="contained"
              fullWidth
              onClick={handleMemberCheckout}
              sx={{
                borderRadius: "999px",
                fontWeight: 600,
                py: 1.5,
                fontSize: isMobile ? "0.95rem" : "1rem",
                color: "#fff",
                "&:hover": {
                  backgroundColor: "#FD7762",
                },
              }}>
              Member Checkout
            </Button>
          </>
        )}
      </Stack>

      {!user && (
        <Typography
          variant="body2"
          sx={{ textAlign: "center", mt: 2, color: "#555" }}>
          Members can view past orders, save their info, and earn rewards.
        </Typography>
      )}
    </Box>
  );
};

export default CartSummaryBox;
